import Text from '../../../../core/utils/Text'
import CoinRow from '../../../common/common/CoinRow'

const OwnerAccountCard = ({ acc, idx, onEdit, onDelete }) => {
	const getRandomBg = (idx) => {
		const bgs = [
			'bg-green-500',
			'bg-blue-500',
			'bg-purple-500',
			'bg-orange-500',
			'bg-red-500',
			'bg-cyan-500',
			'bg-yellow-500',
		]

		return bgs[idx % 7]
	}

	return (
		<div
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
			}}
			className={`w-[360px] rounded-md opacity-100 dark:bg-cardBg bg-gray-100`}
		>
			<div
				className={`w-full h-[35px] ${getRandomBg(
					idx
				)} bg-opacity-30 rounded-md flex items-center justify-center`}
			>
				<span className={'text-sm text-white'}>{acc?.id}</span>
			</div>

			<div className={'grid grid-cols-3 p-3 gap-2 w-full'}>
				<Text className={'text-xs dark:text-slate-300 text-slate-700'} tid={'coin-col'} />
				<div className='flex justify-end col-span-2'>
					<CoinRow coin={{ name: acc.currency, fa: acc.currency, id: acc.currency }} />
				</div>
				<div className={'col-span-3 h-[1px] bg-slate-500/10'} />

				<Text className={'text-xs dark:text-slate-300 text-slate-700'} tid={'name-col'} />
				<div className='flex justify-end col-span-2'>
					<span className={'dark:text-white text-black text-sm'}>{acc?.name}</span>
				</div>
				<div className={'col-span-3 h-[1px] bg-slate-500/10'} />

				<Text className={'text-xs dark:text-slate-300 text-slate-700'} tid={'bankName-col'} />
				<div className='flex justify-end col-span-2'>
					<span className={'dark:text-white text-black text-sm'}>{acc?.bankName}</span>
				</div>
				<div className={'col-span-3 h-[1px] bg-slate-500/10'} />

				<Text className={'text-xs dark:text-slate-300 text-slate-700'} tid={'card-col'} />
				<div className='flex justify-end col-span-2'>
					<span className={'dark:text-white text-black text-sm'}>{acc?.card}</span>
				</div>
				<div className={'col-span-3 h-[1px] bg-slate-500/10'} />

				<Text className={'text-xs dark:text-slate-300 text-slate-700'} tid={'iban-col'} />
				<div className='flex justify-end col-span-2'>
					<span className={'dark:text-white text-black text-sm'}>{acc?.iban}</span>
				</div>
				<div className={'col-span-3 h-[1px] bg-slate-500/10'} />

				<Text className={'text-xs dark:text-slate-300 text-slate-700'} tid={'swift-col'} />
				<div className='flex justify-end col-span-2'>
					<span className={'dark:text-white text-black text-sm'}>{acc?.swift}</span>
				</div>
				<div className={'col-span-3 h-[1px] bg-slate-500/10'} />

				<Text className={'text-xs dark:text-slate-300 text-slate-700'} tid={'number-col'} />
				<div className='flex justify-end col-span-2'>
					<span className={'dark:text-white text-black text-sm'}>{acc?.number}</span>
				</div>

				<div
					className={
						'h-[36px] bg-active w-full col-span-3 mt-3 text-black text-sm cursor-pointer rounded-md flex items-center justify-center'
					}
					onClick={onEdit}
				>
					<Text tid={'edit-owner-account'} />
				</div>

				<div
					className={`border-red-500 border-opacity-20 border-[1px] cursor-pointer
                            text-sm col-span-3 rounded-md h-[36px] w-full flex items-center justify-center
                            `}
					onClick={onDelete}
				>
					<Text tid={'delete-owner-account'} />
				</div>
			</div>
		</div>
	)
}

export default OwnerAccountCard
